module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"brick_name":"Brick name","brick_description":"Brick description"},"fr":{"brick_name":"Nom de la brique","brick_description":"Description de la brique"}}')
  delete Component.options._Ctor
}
